import React from "react";
import ReactDOM from "react-dom/client";

// Self-hosted fonts (no Google Fonts — reliability + GDPR on the public page).
// Lato: 300/400/700/900 for text + display + numerals (900 = CD "Total
// investment" figure). Syne: 700 for the wordmark.
import "@fontsource/lato/300.css";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";
import "@fontsource/lato/900.css";
import "@fontsource/syne/700.css";

import "@/styles/global.css";
import { App } from "@/App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
